type ToggleSwitchProps = {
  label?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  hint?: string;
  checkedLabel?: string;
  uncheckedLabel?: string;
  /** field = bordered row, row = plain label row, compact = switch only */
  variant?: "field" | "row" | "compact";
  className?: string;
};

const ToggleSwitch = ({
  label,
  checked,
  onChange,
  disabled = false,
  hint,
  checkedLabel,
  uncheckedLabel,
  variant = "field",
  className = "",
}: ToggleSwitchProps) => {
  const statusText = checked
    ? checkedLabel || "On"
    : uncheckedLabel || "Off";

  const switchButton = (
    <button
      type="button"
      className={`ui-toggle ${checked ? "checked" : ""}`}
      aria-pressed={checked}
      aria-label={label || statusText}
      disabled={disabled}
      onClick={() => onChange(!checked)}
    >
      <span />
    </button>
  );

  if (variant === "compact") {
    return (
      <div className={`ui-toggle-compact ${className}`.trim()}>
        {switchButton}
      </div>
    );
  }

  if (variant === "row") {
    return (
      <div className={`ui-toggle-row ${disabled ? "is-disabled" : ""} ${className}`.trim()}>
        <div className="ui-toggle-row-text">
          {label && <strong>{label}</strong>}
          {hint && <small>{hint}</small>}
        </div>
        {switchButton}
      </div>
    );
  }

  return (
    <div className={`ui-toggle-field ${disabled ? "is-disabled" : ""} ${className}`.trim()}>
      <div className="ui-toggle-field-text">
        {label && <span className="ui-toggle-label">{label}</span>}
        {(checkedLabel || uncheckedLabel) && (
          <span className={`ui-toggle-status ${checked ? "is-on" : "is-off"}`}>
            {statusText}
          </span>
        )}
        {hint && <small className="ui-toggle-hint">{hint}</small>}
      </div>
      {switchButton}
    </div>
  );
};

export default ToggleSwitch;
